<div class="row mt-3">
    <div class="col-12">
        <hr class="hr mb-0">
    </div>
</div>
@if (!isPiaAuctionScope) {
    <ucs-search-multi-select #dropdownChannel
                             [id]="'search-filter.channel'"
                             [placeholder]="'search-dropdown.placeholder' | translate"
                             [label]="'search-filter.channel' | translate"
                             [states]="channels"
                             (onSelected)="onChangeSearchParamChannels($event)"
                             data-cy="search-filter-dropdown-channels">
    </ucs-search-multi-select>
}
<ucs-search-multi-select #dropdownCountry
                         [id]="'dropdownCountry'"
                         [placeholder]="'search-dropdown.placeholder' | translate"
                         [label]="'search-filter.country' | translate"
                         [states]="countries"
                         (onSelected)="onChangeSearchParamCountry($event);
                                                    searchLocation.clear()"
                         data-cy="search-filter-dropdown-country">
</ucs-search-multi-select>
<div class="row mt-3">
    <div class="col-12">
        <hr class="hr mb-0">
    </div>
</div>
<!-- search vehicles filters -->
<ucs-search-offer-variant [horizontal]="false"
                          (onSearchParamsChanged)="onChangeVehiclesSearchParams($event)">
</ucs-search-offer-variant>
<div class="row mt-3">
    <div class="col-12">
        <hr class="hr mb-0">
    </div>
</div>